import { Box, Flex, Text } from "@chakra-ui/react";
import { brandIconColor, brandTextColor, siteName, siteTagline } from "config";
import React from "react";
import { BsBook } from "react-icons/bs";
import { Link } from "react-router-dom";

interface Props {
  iconSize: string;
  fontSize: string;
  mt: string;
  mb: string;
}

const Logo: React.FC<Props> = ({
  iconSize = "60",
  fontSize = "3xl",
  mt = "8",
  mb = "5",
  ...props
}) => {
  return (
    <>
      <Link to="/">
        <Flex
          alignItems={"center"}
          mt={mt}
          cursor="pointer"
          data-testid="brand-logo"
          {...props}
        >
          <Box data-testid="brand-logo-icon">
            <BsBook size={iconSize} color={brandIconColor} />
          </Box>
          {/* <BookIcon w="10" h="32" fontSize={"2xl"} color="orange.400" /> */}
          <Box
            data-testid="brand-logo-text"
            color={brandTextColor}
            fontWeight={"bold"}
            letterSpacing="wider"
            fontSize={fontSize}
            lineHeight="90%"
            ml="3"
          >
            {siteName}
          </Box>
        </Flex>
        <Text
          data-testid="brand-logo-tagline"
          textAlign={"center"}
          fontFamily="Lexend"
          textTransform={"uppercase"}
          fontSize={{ base: "xs", md: "sm" }}
          letterSpacing="wide"
          color="gray.600"
          mb={mb}
          //@ts-ignore
          display={props.display}
        >
          {siteTagline}
        </Text>
      </Link>
    </>
  );
};

export default Logo;
